import { render, staticRenderFns } from "./OrderInfoDialog.vue?vue&type=template&id=420af2d2&scoped=true"
import script from "./OrderInfoDialog.vue?vue&type=script&lang=ts"
export * from "./OrderInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfoDialog.vue?vue&type=style&index=0&id=420af2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420af2d2",
  null
  
)

export default component.exports